import React from "react";
import useAxios from "axios-hooks";
import OptionsTable from "../../../../../Table/OptionsTable";

const columns = [
  {
    key: "column1",
    name: "Tag ID",
    fieldName: "coBrandTagID",
    maxWidth: 20,
    isResizable: true,
  },
  {
    key: "column2",
    name: "Name",
    fieldName: "name",
    minWidth: 200,
    isResizable: true,
  },
];

const CobrandTagsTable = ({ setOptionTable }) => {
  const [{ data, loading }] = useAxios("/cobrand/tags");

  return (
    <OptionsTable
      columns={columns}
      data={data}
      fieldName="cobrandTag"
      objectKey="coBrandTagID"
      loading={loading}
      setOptionTable={setOptionTable}
      title="Cobrand Tags"
      multiSelect
    />
  );
};

export default CobrandTagsTable;
